<template>
    <div class="error-wrap">
        <div class="wrapper">
            <!-- 登录超时 -->
            <div class="img-wrap" v-if="typeFlag === 0">
                <img src="./../../assets/img/timeout.png" alt="">
                <span class="info">登录超时，请重新登录</span>
            </div>
            <!-- 404 -->
            <div class="img-wrap" v-if="typeFlag === 1">
                <img src="./../../assets/img/404.png" alt="">
            </div>
            <div class="operate-wrap">
                <p>{{time}}s后<a href="">跳转</a>到首页</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            typeFlag: 1, //0 登录超时 1 404
            timer: null,
            time: 3
        };
    },
    methods: {
        fnCountDown() {
            var _this = this;

            clearInterval(_this.timer);
            _this.timer = setInterval(function(){
                _this.time--;
                if(_this.time <= 0) {
                    clearInterval(_this.timer);
                    _this.$router.push({path: '/'});
                }
            },1000);
        }
    },
    mounted() {
        this.fnCountDown();
    },
    created() {
        var _this = this;
        var flag = _this.$route.query.flag;

        // console.log(flag);
        if(flag != undefined){
            _this.typeFlag = parseInt(flag);
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="less" scoped>
.error-wrap {
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 0;
    top: 75px;
    background: #fff;
    border: 1px solid transparent;
    .wrapper {
        display: inline-block;
        transform: translate(-50%, -50%);
        position: absolute;
        left: 50%;
        top: 50%;
        .img-wrap {
            // background: url(../assets/img/timeout.png) no-repeat center center;
            position: relative;
            .info {
                position: absolute;
                left: 50%;
                top: 46px;
                font-size: 20px;
                color: #fff;
                transform: translateX(-30%);
            }
        }
        .operate-wrap {
            text-align: center;
            font-size: 16px;
            margin: 20px 0;
            a {
                padding: 0 5px;
                color: #0000cc;
                text-decoration: underline;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// error.vue?5bc15999